import React, { useContext, useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import onlyWhitespaceInString from '../../../../../services/onlyWhitespaceInString';
import DataContext from '../../../../../context/DataProvider/DataContext';
import { ContractType } from '../../../../../types/ContractType.types';
import titleIsIdentical from '../../../../../services/titleIsIdentical';

interface Props {
  value: string | undefined;
  onValueChange: (value: string) => void;
}

function validateValue(
  inputValue: Props['value'],
  currentValue: string | undefined,
  listOfData: ContractType[],
): { error: boolean; helperText: string } {
  const nameIsIdentical = titleIsIdentical({ inputValue, currentValue, listOfData });

  if (!inputValue) {
    return {
      error: true,
      helperText: 'Pflichtfeld',
    };
  }
  if (onlyWhitespaceInString(inputValue)) {
    return {
      error: true,
      helperText: 'Darf nicht nur aus Leerzeichen bestehen',
    };
  }
  if (inputValue.length > 255) {
    return {
      error: true,
      helperText: 'Max 255 Zeichen lang',
    };
  }
  if (nameIsIdentical) {
    return {
      error: true,
      helperText: 'Titel ist bereits vorhanden',
    };
  }
  return {
    error: false,
    helperText: '',
  };
}

function TextEditor({ value, onValueChange }: Props) {
  const { contractType } = useContext(DataContext);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  const { current: initialValue } = useRef(value);

  useEffect(() => {
    const valid = validateValue(value, initialValue, contractType);
    setError(valid.error);
    setHelperText(valid.helperText);
  }, [value]);
  return (
    <Box>
      <TextField
        value={value || ''}
        onChange={(event) => onValueChange(event.target.value)}
        error={error}
        helperText={helperText}
      />
    </Box>
  );
}

export default TextEditor;
